import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.period.index'),
        name: 'period.index',
        component: () =>
            import(
                /* webpackChunkName: "periods" */ '@/views/periods/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.period.breadcrumb.index'),
                    to: { name: 'period.index' },
                    disable: true,
                },
            ],
        },
    },
]
